import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";

const cookies = new Cookies();

// ============================================================
//  تفاصيل قائمة مشتريات الأجهزة
//
//  ⚠️ الصفحة القديمة (PurchaseListDetail.jsx) كُتب فوقها نسخةٌ من
//  صفحة رواجع الاستبدالات، فصار /purchaseList?id=.. يفتح الاستبدالات.
//  هذه إعادة بناء على عقد GET /purchase/list/:id كما هو — لا تخمين:
//  كل ما تعرضه الصفحة يأتي من الرد، وكل ما تكتبه يذهب لنقطة قائمة.
//
//  الملف القديم لم يُمسّ — التوجيه وحده تغيّر.
// ============================================================

const S = {
  page: { padding: 24, direction: "rtl", background: "#f8fafc", minHeight: "100vh", fontFamily: "'Segoe UI', Tahoma, sans-serif" },
  pageInner: { paddingInline: "max(24px, calc((100% - 1180px) / 2))", boxSizing: "border-box" },
  h1: { fontSize: 24, fontWeight: 800, color: "#0f172a", margin: "0 0 6px" },
  sub: { fontSize: 13, color: "#64748b", margin: "0 0 20px" },
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 1px 3px rgba(0,0,0,.08)", border: "1px solid #eef2f7", marginBottom: 16 },
  pad: { padding: 20 },
  input: { padding: "10px 12px", borderRadius: 10, border: "1px solid #e2e8f0", fontSize: 14, outline: "none", fontFamily: "inherit", width: 120, textAlign: "center" },
  // حقل المجموعة المنتظِرة — الحدّ الكهرماني يقود العين إلى موضع
  // الكتابة نفسه لا إلى الصفّ وحده.
  inputPending: {
    padding: "10px 12px", borderRadius: 10, border: "2px solid #f59e0b", fontSize: 14,
    outline: "none", fontFamily: "inherit", width: 120, textAlign: "center",
    background: "#fff", fontWeight: 700, color: "#92400e",
  },
  // شريط حصيلة التسعير أعلى الجدول
  sortNote: {
    display: "flex", alignItems: "center", gap: 9, flexWrap: "wrap",
    padding: "10px 14px", borderRadius: 11, background: "#fffbeb",
    border: "1px dashed #fde68a", color: "#92400e", fontSize: 13, marginBottom: 12,
  },
  // فاصل «المسعَّرة» — صفٌّ كامل لا خطّ: النصّ يمنع تأويل الفاصل
  // على أنه مجرّد حدٍّ زائد.
  sepCell: {
    padding: "7px 12px", fontSize: 11.5, fontWeight: 700, color: "#94a3b8",
    background: "#f8fafc", textAlign: "right", letterSpacing: ".3px",
    borderTop: "1px solid #e2e8f0", borderBottom: "1px solid #f1f5f9",
  },
  btnPrimary: { padding: "12px 22px", borderRadius: 10, border: "none", background: "#2563eb", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 15 },
  btnOk: { padding: "9px 18px", borderRadius: 10, border: "none", background: "#16a34a", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 14 },
  btnGhost: { padding: "9px 16px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#334155", fontWeight: 600, cursor: "pointer", fontSize: 13 },
  btnDanger: { padding: "6px 13px", borderRadius: 8, border: "1px solid #fecaca", background: "#fff", color: "#dc2626", fontWeight: 700, cursor: "pointer", fontSize: 12.5 },
  btnDisabled: { padding: "9px 18px", borderRadius: 10, border: "1px solid #e2e8f0", background: "#f1f5f9", color: "#94a3b8", fontWeight: 700, cursor: "not-allowed", fontSize: 14 },
  th: { textAlign: "right", padding: "11px 12px", fontSize: 12, color: "#64748b", fontWeight: 700, borderBottom: "2px solid #f1f5f9" },
  td: { textAlign: "right", padding: "12px", fontSize: 13.5, color: "#0f172a", borderBottom: "1px solid #f8fafc", verticalAlign: "middle" },
  stat: { flex: 1, minWidth: 150, padding: "16px 18px", background: "#fff", borderRadius: 14, border: "1px solid #eef2f7" },
  statLabel: { fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 5 },
  statValue: { fontSize: 24, fontWeight: 800, color: "#0f172a" },
  chip: { display: "inline-block", padding: "2px 8px", borderRadius: 12, fontSize: 11, fontWeight: 600, background: "#eff6ff", color: "#2563eb", border: "1px solid #dbeafe", marginInlineEnd: 4, marginBottom: 3 },
  empty: { padding: 50, textAlign: "center", color: "#94a3b8", fontSize: 15 },
  badge: (bg, color) => ({ display: "inline-block", padding: "3px 11px", borderRadius: 20, fontSize: 12, fontWeight: 700, background: bg, color }),
  tabs: { display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" },
  tab: (on) => ({
    padding: "11px 20px", borderRadius: 11, cursor: "pointer", fontSize: 14, fontWeight: 700,
    border: on ? "1px solid #2563eb" : "1px solid #e2e8f0",
    background: on ? "#2563eb" : "#fff", color: on ? "#fff" : "#334155",
  }),
  warnBox: { padding: "13px 16px", borderRadius: 11, background: "#fffbeb", border: "1px solid #fde68a", color: "#92400e", fontSize: 13.5, marginBottom: 14, fontWeight: 600 },
  okBox: { padding: "13px 16px", borderRadius: 11, background: "#f0fdf4", border: "1px solid #bbf7d0", color: "#166534", fontSize: 13.5, marginBottom: 14, fontWeight: 600 },
  errBox: { padding: "13px 16px", borderRadius: 11, background: "#fef2f2", border: "1px solid #fecaca", color: "#b91c1c", fontSize: 13.5, marginBottom: 14, fontWeight: 600 },

  // حقول القفل — اسم التاجر والملاحظات
  fWrap: { marginBottom: 15 },
  fLabel: { display: "block", fontSize: 13, fontWeight: 700, color: "#334155", marginBottom: 6 },
  fReq: { color: "#dc2626", marginInlineStart: 3 },
  fInput: (bad) => ({
    width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: 10,
    border: "1px solid " + (bad ? "#fca5a5" : "#e2e8f0"), fontSize: 14, outline: "none",
    fontFamily: "inherit", color: "#0f172a", background: bad ? "#fef2f2" : "#fff",
  }),
  fArea: {
    width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: 10,
    border: "1px solid #e2e8f0", fontSize: 14, outline: "none", fontFamily: "inherit",
    color: "#0f172a", minHeight: 74, resize: "vertical",
  },
  fHint: { fontSize: 11.5, color: "#94a3b8", marginTop: 5 },
  fSep: { height: 1, background: "#f1f5f9", margin: "18px 0" },
  // شريط مصدر الوجبة أعلى القائمة المقفلة
  srcBar: { padding: "12px 16px", borderRadius: 12, background: "#f8fafc", border: "1px solid #eef2f7", marginBottom: 16 },
  srcLabel: { fontSize: 11.5, color: "#94a3b8", fontWeight: 700, marginBottom: 3 },
  srcVal: { fontSize: 15, fontWeight: 800, color: "#0f172a" },
  srcNote: { fontSize: 13, color: "#475569", marginTop: 8, whiteSpace: "pre-wrap", lineHeight: 1.6 },

  secHead: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", padding: "13px 16px", background: "#f8fafc", borderRadius: 12, border: "1px solid #eef2f7", marginBottom: 10 },
  secName: { fontSize: 15, fontWeight: 800, color: "#0f172a" },

  // نافذة القفل — وسط الصفحة
  overlay: { position: "fixed", inset: 0, background: "rgba(15,23,42,.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 20 },
  modal: { background: "#fff", borderRadius: 18, maxWidth: 560, width: "100%", maxHeight: "85vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,.3)" },
  modalHead: { padding: "18px 22px", borderBottom: "1px solid #f1f5f9" },
  modalBody: { padding: 22 },
  modalFoot: { padding: "16px 22px", borderTop: "1px solid #f1f5f9", display: "flex", gap: 10, justifyContent: "flex-end", flexWrap: "wrap" },
  // الأرقام شارات مستقلة لا نصّ واحد: سردها في سطر يصير غير مقروء
  idBadge: { display: "inline-block", padding: "3px 10px", borderRadius: 8, fontSize: 12.5, fontWeight: 700, background: "#fef2f2", color: "#b91c1c", border: "1px solid #fecaca", marginInlineEnd: 5, marginBottom: 5, fontFamily: "monospace" },
  idBadgeWarn: { display: "inline-block", padding: "3px 10px", borderRadius: 8, fontSize: 12.5, fontWeight: 700, background: "#fffbeb", color: "#92400e", border: "1px solid #fde68a", marginInlineEnd: 5, marginBottom: 5, fontFamily: "monospace" },
};

const fmt = (n) => {
  const v = Number(n) || 0;
  return v % 1 === 0 ? v.toLocaleString("en-US")
    : v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// ============================================================
//  إلحاح التسعير — درجة واحدة تقود الترتيب واللون معاً
//
//  فصلُ الحساب عن العرض مقصود: لو حُسب في مكانين لافترق الترتيب
//  عن التلوين بصمت، فيطلع صفٌّ فوق بلا تمييز أو العكس.
//
//  ٢ = كل أجهزة الصنف بلا سعر · ١ = بعضها · ٠ = كلها مسعَّرة
//  الفرق بين ٢ و ١ ليس تجميلاً: الأول صنفٌ منسيّ بالكامل،
//  والثاني صنفٌ سُعِّر ثم دخله جهازٌ جديد — نظرتان مختلفتان.
// ============================================================
const priceUrgency = (g) => {
  const u = Number(g && g.unpriced_count) || 0;
  if (u <= 0) return 0;
  const c = Number(g && g.count) || 0;
  return (c > 0 && u >= c) ? 2 : 1;
};

// الصفّ كله ملوّن لا الخانة وحدها: العين تلتقط الشريط الأفقي
// قبل أن تقرأ، والجدول عريض فالتمييز الموضعي يضيع في آخره.
const rowBg = (u) => (u === 2 ? { background: "#fffbeb" } : u === 1 ? { background: "#fefce8" } : null);

// شريط رأسي على الحافّة اليمنى (بداية الصفّ في RTL) — أوضح علامة
// تبقى مرئية حتى لو مُرّر الجدول أفقياً.
const leadAccent = (u) => ({
  borderRight: "4px solid " + (u === 2 ? "#f59e0b" : u === 1 ? "#fcd34d" : "transparent"),
});

const BUCKET_AR = { ready: "جاهز", sana: "صيانة", soft: "سوفت", stocked: "في المخزن", sold: "مباع" };
const BUCKET_COLOR = {
  ready: ["#eff6ff", "#2563eb"], sana: ["#fff7ed", "#c2410c"], soft: ["#f5f3ff", "#7c3aed"],
  stocked: ["#f0fdf4", "#166534"], sold: ["#f1f5f9", "#475569"],
};
const bucketAr = (b) => BUCKET_AR[b] || b || "—";
const bucketColor = (b) => BUCKET_COLOR[b] || ["#f1f5f9", "#475569"];

export default class PurchaseListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listId: null,
      data: null,          // رد /purchase/list/:id
      loading: true,
      tab: "verify",       // verify | devices | pricing

      // التسعير: خانة لكل مجموعة
      priceInput: {},      // { [key]: value }
      savingKey: null,
      // مفتاح آخر مجموعة حُفظت — الصفّ ينزل للأسفل بعد الحفظ لأن
      // الترتيب يرفع «بلا سعر» فوق، فبلا وسمٍ يتبعه الفني يظن أن
      // الصفّ اختفى. الوسم يزول وحده بعد ثوانٍ.
      justSavedKey: null,

      // ===== المسح =====
      // الباركود = purchase_device.id، ويقبل السيريال أيضاً.
      scanValue: "",
      scanning: false,
      scanError: "",       // رسالة الخادم ثابتة أمام العين
      // نافذة وسط الصفحة بعد كل مسح — لا سطر في قائمة:
      // التدقيق قرارٌ يتّخذه الفني بعد نظرٍ في الجهاز أمامه، فلو
      // مرّت النتيجة كسطرٍ لأكمل المسح بلا أن ينظر.
      scanResult: null,     // رد verify/scan كاملاً
      scanBusy: false,      // أثناء الرفض/الإعادة للتصحيح من النافذة
      // آخر جهاز أُقرّ — سطر واحد أسفل الحقل مع زر مراجعة
      lastDone: null,

      // القفل
      closeModal: false,
      closing: false,
      // حارس ١ — منع قاطع
      blockUnverified: null,   // { count, ids }
      // حارس ٢ — صار قاطعاً بعد منع التسعير على المقفلة
      blockUnpriced: null,     // { count, ids }

      // ===== المرفوضة =====
      // تُجلب عند فتح تبويبها لا مع القائمة: getListById يستثني
      // المرفوض من كل شيء عمداً، والمرفوض قلّةٌ نادرة الزيارة —
      // فتحميله مع ١٥٠٠ جهازاً يُثقل النداء الأكثر استعمالاً.
      rejected: null,          // { total, by_reason[], devices[] }
      rejectedLoading: false,
      unrejectingId: null,
      // حارس ٣ — اسم التاجر إلزامي، قاطع كحارس التدقيق
      merchantErr: false,
      // يُكتبان مرّة واحدة عند القفل ولا يُعدَّلان بعده
      merchantName: "",
      closeNote: "",
    };
  }

  componentDidMount() {
    this._alive = true;
    const q = new URLSearchParams(window.location.search);
    const id = Number(q.get("id"));
    if (!id) {
      this.setState({ loading: false });
      return;
    }
    this.setState({ listId: id }, this.load);
  }

  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._savedTimer);
  }

  header() { return { "Content-Type": "application/json", token: cookies.get("token") }; }

  load = () => {
    const { listId } = this.state;
    this.setState({ loading: true });
    axios.get(host + `purchase/list/${listId}`, { headers: this.header() })
      .then(res => {
        const data = (res.data && res.data.data) || res.data;
        // الخانات تُملأ من الرد لا تُصفَّر: الفني يرى السعر الحالي
        // قابلاً للتعديل بدل أن يعيد كتابته من الصفر.
        const priceInput = {};
        (data.pricing_groups || []).forEach(g => {
          priceInput[g.key] = g.mixed_price ? "" : String(Number(g.price) || "");
        });
        this.setState({ data, priceInput, loading: false });
      })
      .catch(err => {
        const m = err.response?.data?.message;
        toast.error(typeof m === "string" ? m : "تعذّر جلب القائمة");
        this.setState({ loading: false });
      });
  };

  // ===== التسعير =====
  //
  // السعر يُكتب في أجهزة الصنف داخل هذه القائمة، لا في components.
  // list_id إلزامي هنا: بلاه يسعّر الخادم كل قوائم الصنف.
  savePrice = (g) => {
    const raw = this.state.priceInput[g.key];
    const price = Number(raw);
    if (raw === "" || isNaN(price) || price < 0) {
      toast.error("السعر غير صالح");
      return;
    }
    if (!g.can_save) {
      toast.error("هذه المجموعة بلا صنف — لا يمكن تسعيرها بالمجموعة");
      return;
    }

    this.setState({ savingKey: g.key });
    axios.put(host + 'purchase/group/price', {
      component_id: g.component_id,
      price,
      list_id: this.state.listId,
      token: cookies.get("token"),
    }, { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || res.data;
        toast.success(d?.msg || `تم تسعير ${d?.devices_updated ?? ""} جهاز`);
        this.setState({ savingKey: null, justSavedKey: g.key }, this.load);
        clearTimeout(this._savedTimer);
        this._savedTimer = setTimeout(() => {
          // فحص الحياة إلزامي: الحفظ ثم مغادرة الصفحة قبل انتهاء
          // المؤقّت يستدعي setState على مكوّن مفكوك.
          if (this._alive) this.setState({ justSavedKey: null });
        }, 6000);
      })
      .catch(err => {
        const m = err.response?.data?.message;
        toast.error(typeof m === "string" ? m : "تعذّر التسعير");
        this.setState({ savingKey: null });
      });
  };

  // ============================================================
  //  المسح — جوهر التدقيق
  //
  //  الباركود يحمل purchase_device.id، والحقل يقبل السيريال أيضاً
  //  لأن الملصق قد يكون تالفاً. الخادم يقرّر أيّهما.
  //
  //  المسح **يُدقِّق فعلاً** (يزيد components.count)، فالنافذة بعده
  //  ليست سؤالاً قبل التنفيذ بل مراجعةٌ بعده: إن كان الجهاز غير
  //  مطابق فأمام الفني تراجعان — إعادة للتصحيح أو رفض، وكلاهما
  //  يُنقص العدّ ويُلغي التدقيق.
  // ============================================================
  doScan = () => {
    const code = String(this.state.scanValue || "").trim();
    if (!code) return;

    // حارس مكرّر: الحقل مُخفى في القائمة المقفلة، لكن قارئ الباركود
    // يرسل Enter لأي عنصر مركّز — والخادم يرفض أيضاً، فهذا للرسالة
    // الفورية لا للأمان.
    if (this.state.data?.list?.is_closed) {
      this.setState({
        scanError: "القائمة مقفلة — لا مسح بعد القفل.",
        scanValue: "",
      });
      return;
    }

    this.setState({ scanning: true, scanError: "" });
    axios.post(host + 'purchase/verify/scan', {
      code, token: cookies.get("token"),
    }, { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || res.data;
        this.setState({ scanning: false, scanValue: "", scanError: "", scanResult: d }, this.load);
      })
      .catch(err => {
        const m = err.response?.data?.message;
        const msg = typeof m === "string" ? m : "تعذّر تدقيق الجهاز";
        toast.error(msg);
        // التحديد لا التفريغ: الباركود التالي يستبدل النص، والفني
        // يرى الرقم الفاشل فيعرف أيّ ملصق أعاد قراءته.
        this.setState({ scanning: false, scanError: msg });
        if (this.scanRef) this.scanRef.select();
      });
  };

  onScanKey = (e) => { if (e.key === "Enter") this.doScan(); };

  // إقرار المطابقة — لا نداء: التدقيق وقع عند المسح.
  // الزر يُقرّ فقط ويُخلي الشاشة للمسحة التالية.
  confirmScan = () => {
    const r = this.state.scanResult;
    this.setState({ scanResult: null, lastDone: r ? r.device : null }, () => {
      if (this.scanRef) this.scanRef.focus();
    });
  };

  // إغلاق المراجعة — لا يُقرّ شيئاً ولا يمسّ آخر مُدقَّق
  closeScan = () => {
    this.setState({ scanResult: null }, () => {
      if (this.scanRef) this.scanRef.focus();
    });
  };

  // ===== التراجعان: كلاهما يُلغي التدقيق ويُنقص العدّ =====
  scanAction = (kind) => {
    const r = this.state.scanResult;
    const deviceId = r?.device?.device_id;
    if (!deviceId) return;

    const isReject = kind === 'reject';
    const label = isReject ? 'سبب الرفض' : 'ما يجب تصحيحه';
    const note = window.prompt(`${label} للجهاز #${deviceId}؟ (إلزامي)`);
    if (note === null) return;
    if (!String(note).trim()) {
      toast.error(`${label} إلزامي`);
      return;
    }

    const url = isReject ? 'purchase/verify/reject' : 'purchase/verify/request-fix';
    const body = isReject
      ? { device_id: deviceId, reason: String(note).trim(), token: cookies.get("token") }
      : { device_id: deviceId, note: String(note).trim(), token: cookies.get("token") };

    this.setState({ scanBusy: true });
    axios.put(host + url, body, { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || res.data;
        toast.success(d?.msg || (isReject
          ? `تم رفض الجهاز #${deviceId}`
          : `أُعيد الجهاز #${deviceId} للتصحيح`));
        this.setState({ scanBusy: false, scanResult: null, lastDone: null }, () => {
          this.load();
          if (this.scanRef) this.scanRef.focus();
        });
      })
      .catch(err => {
        const m = err.response?.data?.message;
        toast.error(typeof m === "string" ? m : "تعذّرت العملية");
        this.setState({ scanBusy: false });
      });
  };

  // ===== رفض جهاز من تبويب التدقيق =====
  rejectDevice = (deviceId) => {
    const reason = window.prompt(`سبب رفض الجهاز #${deviceId}؟ (إلزامي)`);
    if (reason === null) return;
    if (!String(reason).trim()) {
      toast.error("سبب الرفض إلزامي");
      return;
    }
    axios.put(host + 'purchase/verify/reject', {
      device_id: deviceId, reason: String(reason).trim(), token: cookies.get("token"),
    }, { headers: this.header() })
      .then(() => { toast.success(`تم رفض الجهاز #${deviceId}`); this.load(); })
      .catch(err => {
        const m = err.response?.data?.message;
        toast.error(typeof m === "string" ? m : "تعذّر الرفض");
      });
  };

  // ===== المرفوضة =====
  loadRejected = () => {
    const { listId } = this.state;
    this.setState({ rejectedLoading: true });
    axios.get(host + `purchase/verify/rejected?list_id=${listId}`, { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || res.data;
        this.setState({ rejected: d || { total: 0, devices: [] }, rejectedLoading: false });
      })
      .catch(() => {
        this.setState({ rejectedLoading: false });
        toast.error("تعذّر جلب الأجهزة المرفوضة");
      });
  };

  openRejected = () => {
    this.setState({ tab: "rejected" });
    if (!this.state.rejected && !this.state.rejectedLoading) this.loadRejected();
  };

  doUnreject = (deviceId) => {
    this.setState({ unrejectingId: deviceId });
    axios.put(host + 'purchase/verify/unreject', {
      device_id: deviceId, token: cookies.get("token"),
    }, { headers: this.header() })
      .then(() => {
        toast.success(`رجع الجهاز #${deviceId} للقائمة`);
        // الاثنان معاً: الجهاز يخرج من قائمة المرفوض ويعود لأقسام
        // القائمة وأعدادها، والعدّادات كلها في الرد الرئيسي.
        this.setState({ unrejectingId: null }, () => { this.loadRejected(); this.load(); });
      })
      .catch(err => {
        const m = err.response?.data?.message;
        toast.error(typeof m === "string" ? m : "تعذّر إلغاء الرفض");
        this.setState({ unrejectingId: null });
      });
  };

  // ============================================================
  //  تبويب المرفوضة
  //
  //  getListById يستثني المرفوض من الأقسام والتسعير والأعداد كلها،
  //  فكانت البطاقة تعرض «مرفوضة: ٣» بلا أي طريق لمعرفة أيّها —
  //  رقمٌ بلا مرجع.
  // ============================================================
  renderRejected() {
    const { rejected, rejectedLoading, unrejectingId } = this.state;
    const closed = !!this.state.data?.list?.is_closed;

    if (rejectedLoading && !rejected) {
      return <div style={{ ...S.card, ...S.empty }}>جارٍ التحميل…</div>;
    }
    const devices = (rejected && rejected.devices) || [];
    if (!devices.length) {
      return <div style={{ ...S.card, ...S.empty }}>لا أجهزة مرفوضة في هذه القائمة.</div>;
    }

    const byReason = (rejected && rejected.by_reason) || [];

    return (
      <>
        {closed ? (
          <div style={S.warnBox}>
            القائمة مقفلة — <b>لا إلغاء رفض بعد القفل</b>. إرجاع جهاز الآن يُدخل
            في القائمة جهازاً لم يدخل سعرُه معدّل الصنف المثبَّت. العرض للمراجعة فقط.
          </div>
        ) : null}

        {byReason.length ? (
          <div style={S.card}>
            <div style={S.pad}>
              <div style={{ fontSize: 13, color: "#64748b", marginBottom: 8 }}>
                الأسباب — تكرارُ سببٍ واحد يدلّ على خلل في الإدخال لا في الأجهزة
              </div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {byReason.map(r => (
                  <span key={r.name} style={S.badge("#fef2f2", "#b91c1c")}>
                    {r.name} · {r.count}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ) : null}

        <div style={S.card}>
          <div style={S.pad}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={S.th}>الرقم</th>
                  <th style={S.th}>الجهاز</th>
                  <th style={S.th}>السيريال</th>
                  <th style={S.th}>السبب</th>
                  <th style={S.th}>من رفضه</th>
                  <th style={S.th}>التاريخ</th>
                  <th style={S.th}></th>
                </tr>
              </thead>
              <tbody>
                {devices.map(dv => (
                  <tr key={dv.device_id}>
                    <td style={S.td}>#{dv.device_id}</td>
                    <td style={S.td}>
                      <div style={{ fontWeight: 700 }}>{dv.composite_name || dv.name}</div>
                      {dv.faults && dv.faults.length ? (
                        <div style={{ marginTop: 3 }}>
                          {dv.faults.map(f => <span key={f} style={S.chip}>{f}</span>)}
                        </div>
                      ) : null}
                    </td>
                    <td style={{ ...S.td, fontFamily: "monospace" }}>{dv.sn}</td>
                    <td style={S.td}>
                      <span style={S.badge("#fef2f2", "#b91c1c")}>
                        {dv.reject_reason || "بلا سبب"}
                      </span>
                    </td>
                    <td style={S.td}>{dv.rejected_by_name || "—"}</td>
                    <td style={S.td}>
                      {dv.rejected_at ? moment(dv.rejected_at).format("YYYY-MM-DD HH:mm") : "—"}
                    </td>
                    <td style={S.td}>
                      {closed ? (
                        <span style={S.badge("#f1f5f9", "#64748b")}>مقفل</span>
                      ) : (
                        <button
                          style={unrejectingId === dv.device_id ? S.btnDisabled : S.btnGhost}
                          disabled={unrejectingId === dv.device_id}
                          onClick={() => this.doUnreject(dv.device_id)}
                        >
                          {unrejectingId === dv.device_id ? "…" : "إلغاء الرفض"}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

  // ===== القفل =====
  //
  // حارسان: التدقيق منعٌ قاطع لا يُتجاوز حتى بـ force، والأسعار
  // تحذير 409 يُتجاوز بعد تأكيد. الخادم هو الحكم — الواجهة تعرض
  // ما يرجعه لا تعيد حساب الشرط بنفسها.
  // لا force بعد اليوم: الحراس الثلاثة قاطعة.
  doClose = () => {
    const { listId, merchantName, closeNote } = this.state;

    // فحص محلّي قبل النداء: الخادم يمنع أيضاً، لكن لا معنى لرحلة
    // شبكة كاملة لحقلٍ فارغ أمام عين المستخدم.
    const merchant = String(merchantName || "").trim();
    if (!merchant) {
      this.setState({ merchantErr: true });
      toast.error("اسم التاجر إلزامي لقفل القائمة");
      return;
    }

    this.setState({ closing: true, blockUnverified: null, blockUnpriced: null, merchantErr: false });

    axios.put(host + `purchase/list/close/${listId}`, {
      closed_by: cookies.get("name") || "",
      // يُثبَّتان مع القفل — لا مسار تعديل بعده
      merchant_name: merchant,
      notes: String(closeNote || "").trim(),
      // النقطة بلا حارس مصادقة، فالتوكن في الجسم — يربط القفل
      // بموظف في سجل الأجهزة بدل «غير معروف».
      token: cookies.get("token"),
    }, { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || res.data;
        toast.success(d?.msg || "تم قفل القائمة");
        (d?.groups || []).forEach(g => toast.info(
          `${g.name}: تكلفة الصنف ${fmt(g.dw_price_before)} ← ${fmt(g.dw_price_after)}`
        ));
        this.setState({ closing: false, closeModal: false }, this.load);
      })
      .catch(err => {
        const body = err.response?.data || {};
        // الجسم قد يكون كائناً داخل message (BadRequestException بكائن)
        const payload = (body.message && typeof body.message === "object")
          ? body.message : body;

        if (payload.unverified_count) {
          this.setState({
            closing: false,
            blockUnverified: {
              count: payload.unverified_count,
              ids: payload.unverified_ids || [],
            },
          });
          return;
        }
        if (payload.unpriced_count) {
          this.setState({
            closing: false,
            blockUnpriced: {
              count: payload.unpriced_count,
              ids: payload.unpriced_ids || [],
            },
          });
          return;
        }

        if (payload.needs_merchant) {
          this.setState({ closing: false, merchantErr: true });
          toast.error("اسم التاجر إلزامي لقفل القائمة");
          return;
        }

        const m = payload.message || body.message;
        toast.error(typeof m === "string" ? m : "تعذّر قفل القائمة");
        this.setState({ closing: false });
      });
  };

  // ============================================================
  //  تبويب التدقيق
  // ============================================================
  renderVerify() {
    const d = this.state.data;
    const v = d.verify || {};
    const pending = Array.isArray(v.pending) ? v.pending : [];
    const { lastDone } = this.state;
    const closed = !!d.list?.is_closed;

    return (
      <>
        {/* ===== حقل المسح ===== */}
        {closed ? (
          // القائمة المقفلة لا تُدقَّق: القفل ثبّت معدّل التكلفة، وأي
          // تدقيق بعده يزيد العدّ بلا أن تدخل تكلفة الجهاز في المعدّل.
          // الحقل يُخفى لا يُعطَّل: حقلٌ ميت أمام قارئ باركود يعني
          // مسحاتٍ تضيع بلا أن يفهم الفني لماذا.
          <div style={S.card}>
            <div style={S.pad}>
              <div style={{ ...S.h1, fontSize: 18 }}>القائمة مقفلة</div>
              <div style={S.errBox}>
                لا مسح بعد القفل. القفل ثبّت معدّل تكلفة كل صنف من أسعار
                أجهزة هذه القائمة، وتدقيق جهاز بعده يزيد العدّ بلا أن تدخل
                تكلفته في المعدّل — فيهبط بلا سبب ولا سبيل لتصحيحه.
              </div>
              <div style={{ fontSize: 13, color: "#475569", lineHeight: 1.8 }}>
                جهاز في هذه القائمة يحتاج تدقيقاً من جديد (أُعيد للتصحيح بعد القفل)؟
                صحّحه في <b>محطة الفحص</b> وأعد إدخاله — فينتقل للقائمة المفتوحة
                ويُدقَّق فيها، وتدخل تكلفته في معدّل تلك القائمة.
              </div>
            </div>
          </div>
        ) : (
          <div style={S.card}>
            <div style={S.pad}>
              <div style={{ ...S.h1, fontSize: 18 }}>مسح جهاز</div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginTop: 10 }}>
                <input
                  ref={el => { this.scanRef = el; }}
                  style={{ ...S.input, width: "auto", flex: 1, minWidth: 260, textAlign: "right", fontSize: 15, padding: "13px 14px" }}
                  placeholder="امسح باركود الجهاز (رقم الجهاز)…"
                  value={this.state.scanValue}
                  onChange={e => this.setState({ scanValue: e.target.value })}
                  onKeyPress={this.onScanKey}
                  autoFocus
                />
                <button
                  style={this.state.scanning ? S.btnDisabled : S.btnPrimary}
                  disabled={this.state.scanning}
                  onClick={this.doScan}
                >
                  {this.state.scanning ? "…" : "تدقيق"}
                </button>
              </div>
              <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 8 }}>
                الباركود هو <code>purchase_device.id</code> — ويقبل السيريال أيضاً.
                كل جهاز يُمسح <b>مرة واحدة</b>.
              </div>

              {/* خطأ المسح ثابت أمام العين لا toast يزول: الفني ينظر
                  للجهاز في يده لا للشاشة، فالإشعار العابر يفوته. */}
              {this.state.scanError ? (
                <div style={{ ...S.errBox, marginTop: 12, marginBottom: 0 }}>
                  {this.state.scanError}
                </div>
              ) : null}

              {/* آخر جهاز أُقرّ — سطر واحد لا بطاقة: البطاقة المكرّرة
                  تحت الحقل تسرق النظر من النافذة وتُبعد الحقل عن العين. */}
              {lastDone ? (
                <div style={{
                  display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap",
                  marginTop: 12, padding: "10px 14px", borderRadius: 11,
                  background: "#f0fdf4", border: "1px solid #bbf7d0",
                }}>
                  <span style={S.badge("#dcfce7", "#166534")}>آخر مُدقَّق</span>
                  <span style={{ fontWeight: 700, fontSize: 13.5 }}>#{lastDone.device_id}</span>
                  <span style={{ fontSize: 13 }}>{lastDone.composite_name}</span>
                  <button
                    style={{ ...S.btnGhost, marginInlineStart: "auto" }}
                    onClick={() => this.setState({ scanResult: { device: lastDone, review: true } })}
                  >
                    مراجعة
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        )}

        {v.matched ? (
          <div style={S.okBox}>
            كل أجهزة القائمة مُدقَّقة ({v.verified_count}) — القائمة جاهزة للقفل.
          </div>
        ) : (
          <div style={S.warnBox}>
            {v.pending_count} جهاز لم يُدقَّق بعد. القفل ممنوع حتى يُمسح كلٌّ منها
            بالباركود في صفحة التحويل للمخزن — أو يُرفض بسبب.
          </div>
        )}

        <div style={S.card}>
          <div style={S.pad}>
            <div style={{ ...S.h1, fontSize: 18 }}>الأجهزة المعلّقة</div>
            <div style={S.sub}>
              مسحُها يجري من محطة الفحص أو صفحة التحويل. هنا تُراجَع وتُرفض فقط.
            </div>

            {!pending.length ? (
              <div style={S.empty}>ما في أجهزة معلّقة.</div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={S.th}>الرقم</th>
                    <th style={S.th}>الاسم المركّب</th>
                    <th style={S.th}>السيريال</th>
                    <th style={S.th}>البطارية</th>
                    <th style={S.th}>الأعطال</th>
                    <th style={S.th}>المُدخِل</th>
                    <th style={S.th}></th>
                  </tr>
                </thead>
                <tbody>
                  {pending.map(p => (
                    <tr key={p.device_id || p.id}>
                      <td style={{ ...S.td, fontWeight: 700 }}>#{p.device_id || p.id}</td>
                      <td style={S.td}>{p.composite_name || "—"}</td>
                      <td style={{ ...S.td, fontFamily: "monospace", fontSize: 12.5 }}>{p.sn || "—"}</td>
                      <td style={S.td}>{p.battery ? `${p.battery}%` : "—"}</td>
                      <td style={S.td}>
                        {Array.isArray(p.faults) && p.faults.length
                          ? p.faults.map((f, i) => <span key={i} style={S.chip}>{f}</span>)
                          : "—"}
                      </td>
                      <td style={S.td}>{p.added_by_name || "—"}</td>
                      <td style={S.td}>
                        <button style={S.btnDanger} onClick={() => this.rejectDevice(p.device_id || p.id)}>
                          رفض
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </>
    );
  }

  // ============================================================
  //  تبويب الأجهزة — مجموعات بالصنف والحالة
  // ============================================================
  renderDevices() {
    const d = this.state.data;
    const sections = Array.isArray(d.sections) ? d.sections : [];

    if (!sections.length) {
      return <div style={{ ...S.card, ...S.empty }}>لا أجهزة في هذه القائمة.</div>;
    }

    return sections.map(sec => {
      const [bg, color] = bucketColor(sec.bucket);
      return (
        <div key={sec.key} style={S.card}>
          <div style={S.pad}>
            <div style={S.secHead}>
              <span style={S.secName}>{sec.composite_name}</span>
              <span style={S.badge(bg, color)}>{bucketAr(sec.bucket)}</span>
              {sec.sub_label ? <span style={S.chip}>{sec.sub_label}</span> : null}
              <span style={S.chip}>{sec.count} جهاز</span>
              {sec.pending_count ? (
                <span style={S.badge("#fffbeb", "#92400e")}>{sec.pending_count} غير مُدقَّق</span>
              ) : (
                <span style={S.badge("#f0fdf4", "#166534")}>كلها مُدقَّقة</span>
              )}
              <span style={{ marginInlineStart: "auto", fontWeight: 800, fontSize: 15 }}>
                {fmt(sec.total)}
              </span>
            </div>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={S.th}>الرقم</th>
                  <th style={S.th}>السيريال</th>
                  <th style={S.th}>الماك</th>
                  <th style={S.th}>التدقيق</th>
                  <th style={S.th}>السعر</th>
                  <th style={S.th}>القطع</th>
                  <th style={S.th}>الفتح</th>
                  <th style={S.th}>التكلفة</th>
                </tr>
              </thead>
              <tbody>
                {(sec.devices || []).map(x => (
                  <tr key={x.device_id}>
                    <td style={{ ...S.td, fontWeight: 700 }}>#{x.device_id}</td>
                    <td style={{ ...S.td, fontFamily: "monospace", fontSize: 12.5 }}>{x.sn}</td>
                    <td style={{ ...S.td, fontFamily: "monospace", fontSize: 12 }}>
                      {x.wifi_mac || <span style={S.badge("#fffbeb", "#92400e")}>طافي</span>}
                    </td>
                    <td style={S.td}>
                      {x.is_verified ? (
                        <span style={S.badge("#f0fdf4", "#166534")}>
                          {x.verified_by_name || "مُدقَّق"}
                        </span>
                      ) : (
                        <span style={S.badge("#fef2f2", "#b91c1c")}>معلّق</span>
                      )}
                    </td>
                    <td style={S.td}>
                      {Number(x.price) ? fmt(x.price)
                        : <span style={S.badge("#fffbeb", "#92400e")}>بلا سعر</span>}
                    </td>
                    <td style={S.td}>{Number(x.parts_cost) ? fmt(x.parts_cost) : "—"}</td>
                    <td style={S.td}>{Number(x.unlock_cost) ? fmt(x.unlock_cost) : "—"}</td>
                    <td style={{ ...S.td, fontWeight: 700 }}>{fmt(x.total_cost)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    });
  }

  // ============================================================
  //  تبويب التسعير — بالصنف وحده
  //
  //  التقسيم هنا يخلو من الحالة عمداً: التسعير يخصّ دفعة الشراء،
  //  وكون جهاز بِيع والآخر في المخزن لا يغيّر ما دُفع فيهما. وهذا
  //  يطابق ما يفعله setGroupPrice فعلاً (componentId + listId).
  // ============================================================
  renderPricing() {
    const d = this.state.data;
    const groups = Array.isArray(d.pricing_groups) ? d.pricing_groups : [];
    const closed = !!d.list?.is_closed;

    if (!groups.length) {
      return <div style={{ ...S.card, ...S.empty }}>لا أجهزة لتسعيرها.</div>;
    }

    // ===== الترتيب: بلا سعر أولاً =====
    //
    // نسخة لا الأصل: sort يعدّل المصفوفة في مكانها، وهذه المصفوفة
    // داخل this.state.data — ترتيبها هنا تعديلٌ للحالة خارج setState.
    //
    // الرتبة الأولى هي الإلحاح، والثانية عدد الأجهزة بلا سعر (الصنف
    // الذي فيه ٢٠ جهازاً منسيّاً أولى من الذي فيه واحد)، والثالثة
    // الموضع الأصلي — تثبيتٌ صريح لا اتكال على استقرار sort، فالصنفان
    // المتساويان لو تبادلا الموضع بين تحميلين قفزا تحت يد الفني.
    const ordered = groups
      .map((g, i) => ({ g, i, u: priceUrgency(g) }))
      .sort((a, b) => (b.u - a.u)
        || ((Number(b.g.unpriced_count) || 0) - (Number(a.g.unpriced_count) || 0))
        || (a.i - b.i));

    const pendingGroups = ordered.filter(o => o.u > 0).length;
    const pendingDevices = ordered.reduce((s, o) => s + (Number(o.g.unpriced_count) || 0), 0);

    return (
      <>
        {closed ? (
          // كان التسعير مسموحاً هنا «بأثر رجعي»، وكان يترك
          // purchase_device.price يتغيّر و components.dw_price المجمَّد
          // على حاله — رقمان للتكلفة الواحدة يفترقان بصمت.
          <div style={S.errBox}>
            القائمة مقفلة — <b>لا تسعير بعد القفل</b>. القفل ثبّت معدّل تكلفة
            كل صنف من هذه الأسعار، وتغييرها بعده يجعل سعر الجهاز يفترق عن
            المعدّل المثبَّت بلا أن يُعاد حسابه.
          </div>
        ) : d.unpriced_count ? (
          <div style={S.warnBox}>
            {d.unpriced_count} جهاز بلا سعر — <b>القفل ممنوع حتى تُسعَّر كلها.</b>
            لا تجاوز: الجهاز الذي يُقفل بصفر يبقى بتكلفة صفر إلى الأبد.
          </div>
        ) : (
          <div style={S.okBox}>كل الأجهزة مسعَّرة.</div>
        )}

        <div style={S.card}>
          <div style={S.pad}>
            {/* شريط الحصيلة — يُقرأ قبل النظر في الجدول: كم صنفاً
                ينتظر وكم جهازاً وراءه. يختفي حين لا ينتظر شيء. */}
            {pendingGroups ? (
              <div style={S.sortNote}>
                <span style={S.badge("#fffbeb", "#92400e")}>بلا سعر</span>
                <span>
                  <b>{pendingGroups}</b> صنف ينتظر التسعير
                  (<b>{pendingDevices}</b> جهاز) — مرفوعةٌ إلى أعلى الجدول.
                </span>
              </div>
            ) : null}

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={S.th}>الصنف</th>
                  <th style={S.th}>العدد</th>
                  <th style={S.th}>التوزيع</th>
                  <th style={S.th}>بلا سعر</th>
                  <th style={S.th}>سعر الوحدة</th>
                  <th style={S.th}>الإجمالي</th>
                  <th style={S.th}></th>
                </tr>
              </thead>
              <tbody>
                {ordered.map(({ g, u }, idx) => [
                  // فاصل بصريّ عند حدّ آخر صنفٍ ينتظر: بلاه يبقى الحدّ
                  // مستنتَجاً من اللون وحده، واللون يضعف في الشاشات
                  // الرديئة وطابعات الشاشة.
                  (u === 0 && idx > 0 && ordered[idx - 1].u > 0) ? (
                    <tr key={g.key + "__sep"}>
                      <td colSpan={7} style={S.sepCell}>المسعَّرة</td>
                    </tr>
                  ) : null,

                  <tr key={g.key} style={rowBg(u) || undefined}>
                    <td style={{ ...S.td, ...leadAccent(u) }}>
                      <div style={{ fontWeight: 700 }}>{g.composite_name}</div>
                      {g.sub_label ? <span style={S.chip}>{g.sub_label}</span> : null}
                      {!g.can_save ? (
                        <span style={S.badge("#fef2f2", "#b91c1c")}>بلا صنف</span>
                      ) : null}
                      {/* الشارة تقول أيّ الحالتين: صنفٌ لم يُسعَّر أصلاً
                          أم صنفٌ سُعِّر ودخله جديد. */}
                      {u === 2 ? (
                        <span style={{ ...S.badge("#fef3c7", "#92400e"), marginInlineStart: 6 }}>
                          بلا سعر
                        </span>
                      ) : u === 1 ? (
                        <span style={{ ...S.badge("#fefce8", "#a16207"), marginInlineStart: 6 }}>
                          سعر ناقص
                        </span>
                      ) : null}
                      {this.state.justSavedKey === g.key ? (
                        <span style={{ ...S.badge("#f0fdf4", "#166534"), marginInlineStart: 6 }}>
                          ✓ حُفظ
                        </span>
                      ) : null}
                    </td>
                    <td style={S.td}>{g.count}</td>
                    <td style={S.td}>
                      {Object.keys(g.by_status || {}).map(k => (
                        <span key={k} style={S.chip}>{bucketAr(k)} {g.by_status[k]}</span>
                      ))}
                    </td>
                    <td style={S.td}>
                      {g.unpriced_count
                        ? (
                          <span style={{
                            ...S.badge(u === 2 ? "#f59e0b" : "#fef3c7", u === 2 ? "#fff" : "#92400e"),
                            fontFamily: "monospace", fontSize: 13,
                          }}>
                            {g.unpriced_count}{u === 1 ? ` / ${g.count}` : ""}
                          </span>
                        )
                        : "—"}
                    </td>
                    <td style={S.td}>
                      {closed ? (
                        // نصّ لا حقل معطَّل: الحقل المعطَّل يبقى يُغري
                        // بالنقر ويوحي بأن المنع عارض.
                        <span style={{ fontWeight: 700 }}>
                          {g.mixed_price ? "مختلفة" : fmt(Number(g.price) || 0)}
                        </span>
                      ) : (
                        <input
                          style={u ? S.inputPending : S.input}
                          type="number"
                          min="0"
                          placeholder={g.mixed_price ? "مختلفة" : "0"}
                          value={this.state.priceInput[g.key] ?? ""}
                          onChange={e => this.setState({
                            priceInput: Object.assign({}, this.state.priceInput, { [g.key]: e.target.value }),
                          })}
                        />
                      )}
                      {/* الضرب يكذب حين تختلف الأسعار، فالعلم إلزامي
                          لا تجميلي: بلاه يظن الفني أن السعر المعروض
                          يمثّل المجموعة كلها. */}
                      {g.mixed_price ? (
                        <div style={{ marginTop: 5 }}>
                          <span style={S.badge("#fffbeb", "#92400e")}>⚠ أسعار مختلفة</span>
                        </div>
                      ) : null}
                    </td>
                    <td style={{ ...S.td, fontWeight: 700 }}>{fmt(g.total)}</td>
                    <td style={S.td}>
                      {closed ? (
                        <span style={S.badge("#f1f5f9", "#64748b")}>مقفل</span>
                      ) : (
                        <button
                          style={(this.state.savingKey === g.key || !g.can_save) ? S.btnDisabled : S.btnOk}
                          disabled={this.state.savingKey === g.key || !g.can_save}
                          onClick={() => this.savePrice(g)}
                        >
                          {this.state.savingKey === g.key ? "…" : "حفظ"}
                        </button>
                      )}
                    </td>
                  </tr>,
                ])}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

  // ============================================================
  //  نافذة المسح — وسط الصفحة بعد كل مسح
  //
  //  ثلاثة أزرار لا زرّان: «مطابقة» تُقرّ ما وقع، و«إعادة للتصحيح»
  //  و«رفض» تراجعان مختلفان جوهرياً — الأولى تُرجع الجهاز للفني
  //  ببياناتٍ تُصحَّح ثم يُدقَّق ثانيةً، والثانية تُخرجه من الدورة.
  // ============================================================
  renderScanModal() {
    const r = this.state.scanResult;
    const dev = r?.device || {};
    const busy = this.state.scanBusy;

    // ===== المراجعة قراءة فقط =====
    // الأزرار الثلاثة تُعرض للمسحة الطازجة وحدها. جهازٌ أُقرّ سلفاً
    // لو عُرض بنفس الأزرار لصار «رفض» بضغطة غلط يُلغي تدقيقاً صحيحاً
    // ويُنقص العدّ — والفني فتح النافذة ليقرأ لا ليقرّر.
    // التراجع يبقى متاحاً من تبويب التدقيق وقائمة الأجهزة.
    const review = !!r?.review;

    return (
      <div style={S.overlay} onClick={() => !busy && (review ? this.closeScan() : this.confirmScan())}>
        <div style={S.modal} onClick={e => e.stopPropagation()}>
          <div style={S.modalHead}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              <span style={{ fontSize: 22, fontWeight: 800, color: "#0f172a" }}>
                #{dev.device_id}
              </span>
              {/* الشارة أهم ما في النافذة: دخول المخزن يعني أن العدّ
                  زاد فعلاً، والتراجع عنه يُنقصه. */}
              {r?.stocked_now ? (
                <span style={S.badge("#f0fdf4", "#166534")}>📦 دخل المخزن</span>
              ) : null}
              {review ? (
                <span style={S.badge("#f1f5f9", "#475569")}>مراجعة — قراءة فقط</span>
              ) : null}
              {dev.is_floating ? <span style={S.badge("#fffbeb", "#92400e")}>طافي</span> : null}
              {dev.needs_fix ? <span style={S.badge("#fef2f2", "#b91c1c")}>معاد للتصحيح</span> : null}
            </div>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#334155", marginTop: 6 }}>
              {dev.composite_name}
            </div>
            {r?.msg ? (
              <div style={{ fontSize: 12.5, color: "#64748b", marginTop: 4 }}>{r.msg}</div>
            ) : null}
          </div>

          <div style={S.modalBody}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                {[
                  ["السيريال", dev.sn || "—", true],
                  ["الماك", dev.wifi_mac || (dev.pending_mac ? "ينتظر الربط" : "—"), true],
                  ["الذاكرة", dev.storage || "—", false],
                  ["البطارية", dev.battery ? `${dev.battery}%` : "—", false],
                  ["الحالة", dev.status_label || dev.status || "—", false],
                  ["المُدخِل", dev.added_by_name || "—", false],
                  ["الأعطال", dev.faults_text || "بلا أعطال", false],
                ].map(([k, val, mono]) => (
                  <tr key={k}>
                    <td style={{ ...S.td, width: 120, color: "#64748b", fontWeight: 600, fontSize: 12.5 }}>{k}</td>
                    <td style={{ ...S.td, fontFamily: mono ? "monospace" : "inherit" }}>{val}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* توريث السعر: الفني يجب أن يعرف أن الرقم جاء من
                المجموعة لا من إدخاله، وإلا حسبه سعراً أدخله بنفسه. */}
            {r?.price_inherited ? (
              <div style={{ ...S.okBox, marginTop: 14, marginBottom: 0 }}>
                ورّث سعر المجموعة: {fmt(r.price_inherited)}
              </div>
            ) : null}
            {Array.isArray(r?.price_group_mixed) && r.price_group_mixed.length ? (
              <div style={{ ...S.warnBox, marginTop: 14, marginBottom: 0 }}>
                مجموعة هذا الصنف فيها أسعار مختلفة ({r.price_group_mixed.map(x => fmt(x)).join(' · ')})
                — لم يُورَّث سعر، سعّره صراحةً من تبويب التسعير.
              </div>
            ) : null}
            {!Number(dev.price) && !r?.price_inherited ? (
              <div style={{ ...S.warnBox, marginTop: 14, marginBottom: 0 }}>
                الجهاز بلا سعر — لن يمنع القفل لكنه يدخل بتكلفة صفر.
              </div>
            ) : null}
          </div>

          <div style={S.modalFoot}>
            {review ? (
              <>
                <span style={{ fontSize: 12.5, color: "#94a3b8", marginInlineEnd: "auto" }}>
                  الجهاز أُقرّ سلفاً — الرفض والإعادة للتصحيح من تبويب التدقيق
                </span>
                <button style={S.btnGhost} onClick={this.closeScan}>إغلاق</button>
              </>
            ) : (
              <>
                <button
                  style={busy ? S.btnDisabled : S.btnDanger}
                  disabled={busy}
                  onClick={() => this.scanAction('reject')}
                >
                  رفض
                </button>
                <button
                  style={busy ? S.btnDisabled : S.btnGhost}
                  disabled={busy}
                  onClick={() => this.scanAction('fix')}
                >
                  إعادة للتصحيح
                </button>
                <button
                  style={busy ? S.btnDisabled : S.btnOk}
                  disabled={busy}
                  onClick={this.confirmScan}
                >
                  مطابقة
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ============================================================
  //  نافذة القفل
  // ============================================================
  renderCloseModal() {
    const {
      blockUnverified, blockUnpriced, closing,
      merchantName, closeNote, merchantErr,
    } = this.state;
    const d = this.state.data;
    // حارسان قاطعان: أيّهما وقع فالقفل مستحيل، والحقول تُخفى معه.
    const blocked = blockUnverified || blockUnpriced;
    // الحقول جزء من حمولة القفل لا من نتيجته، فتبقى ظاهرة مع تحذير
    // الأسعار أيضاً — لولا ذلك لاختفى ما كتبه المستخدم أمام عينه.
    // تُخفى وحدها مع المنع القاطع: القفل مستحيل، والرسالة يجب أن تبقى وحدها.
    const canClose = !!String(merchantName || "").trim();

    return (
      <div style={S.overlay} onClick={() => !closing && this.setState({ closeModal: false })}>
        <div style={S.modal} onClick={e => e.stopPropagation()}>
          <div style={S.modalHead}>
            <div style={{ fontSize: 19, fontWeight: 800, color: "#0f172a" }}>
              قفل قائمة المشتريات #{d.list?.id}
            </div>
          </div>

          <div style={S.modalBody}>
            {blocked ? (
              <>
                {blockUnverified ? (
                  <>
                    <div style={S.errBox}>
                      {blockUnverified.count} جهاز لم يُدقَّق — القفل ممنوع.
                      هذا الحارس <b>لا يُتجاوز</b>: الجهاز غير المُدقَّق لم يدخل العدّ
                      ولا ارتبط بصنف، فقفلُ القائمة بوجوده يُثبّت معدّلاً ناقصاً
                      لا سبيل لتصحيحه بعد القفل.
                    </div>
                    <div>
                      {blockUnverified.ids.map(id => (
                        <span key={id} style={S.idBadge}>#{id}</span>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <div style={S.errBox}>
                      {blockUnpriced.count} جهاز بلا سعر — القفل ممنوع.
                      صار هذا الحارس <b>قاطعاً</b> بعد منع التسعير على القائمة
                      المقفلة: لو مرّ الجهاز بصفر لبقي بتكلفة صفر إلى الأبد،
                      يهبط بمعدّل صنفه بلا أي طريق لتصحيحه.
                    </div>
                    <div>
                      {blockUnpriced.ids.map(id => (
                        <span key={id} style={S.idBadge}>#{id}</span>
                      ))}
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                {(
                  <>
                    <div style={S.warnBox}>
                      القفل يُثبّت معدّل تكلفة كل صنف من أسعار أجهزة هذه القائمة،
                      ويعيد حساب تكلفة الطلبات التي فيها أجهزة منها. <b>لا تراجع بعده.</b>
                    </div>
                    <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                      <div style={S.sumLike || S.stat}>
                        <div style={S.statLabel}>الأجهزة</div>
                        <div style={S.statValue}>{d.verify?.total ?? 0}</div>
                      </div>
                      <div style={S.stat}>
                        <div style={S.statLabel}>بلا سعر</div>
                        <div style={S.statValue}>{d.unpriced_count ?? 0}</div>
                      </div>
                      <div style={S.stat}>
                        <div style={S.statLabel}>الإجمالي</div>
                        <div style={S.statValue}>{fmt(d.grandTotal)}</div>
                      </div>
                    </div>
                  </>
                )}

                <div style={S.fSep} />

                {/* مصدر الوجبة — يُكتب مرّة واحدة مع القفل */}
                <div style={S.fWrap}>
                  <label style={S.fLabel}>
                    اسم التاجر<span style={S.fReq}>*</span>
                  </label>
                  <input
                    style={S.fInput(merchantErr && !canClose)}
                    value={merchantName}
                    maxLength={160}
                    disabled={closing}
                    autoFocus
                    placeholder="التاجر الذي اشتُريت منه الوجبة"
                    onChange={e => this.setState({ merchantName: e.target.value, merchantErr: false })}
                  />
                  <div style={S.fHint}>
                    إلزامي — بلا مصدر الوجبة لا تُراجَع تسعيرة ولا يُطالَب تاجر بجهاز خرج عاطلاً.
                  </div>
                </div>

                <div style={S.fWrap}>
                  <label style={S.fLabel}>ملاحظات الوجبة</label>
                  <textarea
                    style={S.fArea}
                    value={closeNote}
                    maxLength={999}
                    disabled={closing}
                    placeholder="اختياري — الاتفاق، طريقة الدفع، أي شيء يفيد لاحقاً"
                    onChange={e => this.setState({ closeNote: e.target.value })}
                  />
                  <div style={S.fHint}>{(closeNote || "").length}/999</div>
                </div>

                <div style={S.errBox}>
                  ⚠️ الاسم والملاحظات <b>يُثبَّتان نهائياً</b> مع القفل — لا مسار لتعديلهما بعده.
                </div>
              </>
            )}
          </div>

          <div style={S.modalFoot}>
            <button
              style={S.btnGhost}
              disabled={closing}
              onClick={() => this.setState({ closeModal: false })}
            >
              رجوع
            </button>

            {blocked ? (
              // لا زرّ قفل إطلاقاً — الحارسان قاطعان. الزرّ ينقل
              // إلى التبويب الذي يُصلَح فيه الخلل.
              <button
                style={S.btnGhost}
                onClick={() => this.setState({
                  closeModal: false,
                  tab: blockUnverified ? "verify" : "pricing",
                })}
              >
                {blockUnverified ? "اعرض المعلّقة" : "اعرض غير المسعَّرة"}
              </button>
            ) : (
              // معطّل حتى يُكتب اسم التاجر — نفس نمط قرار البصمة الإجباري
              <button
                style={(closing || !canClose) ? S.btnDisabled : S.btnPrimary}
                disabled={closing || !canClose}
                title={!canClose ? "اكتب اسم التاجر أولاً" : ""}
                onClick={() => this.doClose()}
              >
                {closing ? "…" : "تأكيد القفل"}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (!cookies.get("token")) return <div style={S.page}>يجب تسجيل الدخول</div>;

    const { data, loading, tab, listId } = this.state;

    if (!listId) {
      return (
        <div style={S.page}><div style={S.pageInner}>
          <div style={{ ...S.card, ...S.empty }}>
            ما في رقم قائمة في الرابط. افتح القائمة من صفحة «مشتريات الأجهزة».
          </div>
        </div></div>
      );
    }
    if (loading) return <div style={S.page}><div style={S.pageInner}><div style={{ ...S.card, ...S.empty }}>…</div></div></div>;
    if (!data) {
      return (
        <div style={S.page}><div style={S.pageInner}>
          <div style={{ ...S.card, ...S.empty }}>تعذّر جلب القائمة #{listId}.</div>
        </div></div>
      );
    }

    const list = data.list || {};
    const closed = !!list.is_closed;

    return (
      <div style={S.page}>
        <div style={S.pageInner}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 12, flexWrap: "wrap" }}>
            <div>
              <h1 style={S.h1}>قائمة مشتريات #{list.id}</h1>
              <p style={S.sub}>
                {closed
                  ? `مقفلة${list.closed_by ? ` — ${list.closed_by}` : ""}${list.closed_at ? ` · ${moment(list.closed_at).format("YYYY-MM-DD HH:mm")}` : ""}`
                  : "مفتوحة — الأجهزة تُدخل من محطة الفحص وتُدقَّق من لوحة التحكم"}
              </p>
            </div>
            <div style={{ marginInlineStart: "auto", display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button style={S.btnGhost} onClick={this.load}>تحديث</button>
              <button style={S.btnGhost} onClick={() => { window.location.href = '/purchaseLists'; }}>
                كل القوائم
              </button>
              {!closed ? (
                <button style={S.btnPrimary} onClick={() => this.setState({
                  closeModal: true, blockUnverified: null, blockUnpriced: null,
                })}>
                  قفل القائمة
                </button>
              ) : (
                <span style={S.badge("#f1f5f9", "#475569")}>مقفلة</span>
              )}
            </div>
          </div>

          {/* مصدر الوجبة — يظهر بعد القفل فقط.
              القوائم المقفلة قبل هذه الميزة اسمها فارغ، فلا يُعرض الشريط. */}
          {closed && (list.merchant_name || list.notes) ? (
            <div style={S.srcBar}>
              {list.merchant_name ? (
                <>
                  <div style={S.srcLabel}>التاجر</div>
                  <div style={S.srcVal}>{list.merchant_name}</div>
                </>
              ) : null}
              {list.notes ? <div style={S.srcNote}>{list.notes}</div> : null}
            </div>
          ) : null}

          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
            <div style={S.stat}>
              <div style={S.statLabel}>الأجهزة</div>
              <div style={S.statValue}>{data.verify?.total ?? 0}</div>
            </div>
            <div style={S.stat}>
              <div style={S.statLabel}>مُدقَّقة</div>
              <div style={{ ...S.statValue, color: data.verify?.matched ? "#166534" : "#0f172a" }}>
                {data.verify?.verified_count ?? 0}
              </div>
            </div>
            <div style={S.stat}>
              <div style={S.statLabel}>معلّقة</div>
              <div style={{ ...S.statValue, color: (data.verify?.pending_count ? "#b91c1c" : "#0f172a") }}>
                {data.verify?.pending_count ?? 0}
              </div>
            </div>
            <div style={S.stat}>
              <div style={S.statLabel}>بلا سعر</div>
              <div style={{ ...S.statValue, color: (data.unpriced_count ? "#92400e" : "#0f172a") }}>
                {data.unpriced_count ?? 0}
              </div>
            </div>
            {/* رقمٌ بلا مرجع كان: يُعرض العدد ولا سبيل لرؤية أيّها.
                البطاقة نفسها صارت المدخل. */}
            <div
              style={Object.assign({}, S.stat, (data.rejected_count ? { cursor: "pointer" } : null))}
              onClick={() => { if (data.rejected_count) this.openRejected(); }}
              title={data.rejected_count ? "اعرض الأجهزة المرفوضة" : ""}
            >
              <div style={S.statLabel}>مرفوضة</div>
              <div style={{ ...S.statValue, color: data.rejected_count ? "#b91c1c" : "#0f172a" }}>
                {data.rejected_count ?? 0}
              </div>
            </div>
            <div style={S.stat}>
              <div style={S.statLabel}>الإجمالي</div>
              <div style={S.statValue}>{fmt(data.grandTotal)}</div>
            </div>
          </div>

          <div style={S.tabs}>
            <div style={S.tab(tab === "verify")} onClick={() => this.setState({ tab: "verify" })}>
              التدقيق {data.verify?.pending_count ? `(${data.verify.pending_count})` : ""}
            </div>
            <div style={S.tab(tab === "devices")} onClick={() => this.setState({ tab: "devices" })}>
              الأجهزة
            </div>
            <div style={S.tab(tab === "pricing")} onClick={() => this.setState({ tab: "pricing" })}>
              التسعير {data.unpriced_count ? `(${data.unpriced_count})` : ""}
            </div>
            {/* يظهر فقط حين يوجد مرفوض — تبويبٌ دائم بصفر ضجيج */}
            {data.rejected_count ? (
              <div style={S.tab(tab === "rejected")} onClick={this.openRejected}>
                مرفوضة ({data.rejected_count})
              </div>
            ) : null}
          </div>

          {tab === "verify" ? this.renderVerify()
            : tab === "devices" ? this.renderDevices()
              : tab === "rejected" ? this.renderRejected()
                : this.renderPricing()}
        </div>

        {/* نافذة المسح فوق نافذة القفل في الترتيب: لو فُتحت الثانية
            بالخطأ أثناء مراجعة مسحة، تبقى المسحة هي المرئية. */}
        {this.state.closeModal ? this.renderCloseModal() : null}
        {this.state.scanResult ? this.renderScanModal() : null}

        <ToastContainer position="top-center" autoClose={3000} rtl theme="colored" />
      </div>
    );
  }
}
